import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  Spinner,
  Text,
  Textarea,
  useDisclosure
} from '@chakra-ui/react';
import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import Licensee from '../../model/licensee.mjs';
import './TransferForm.scss';
import { FirearmType } from '@/model/firearm-type.mjs';
import Transfer from '@/model/transfer.mjs';
import { LicenseById, createTransfer } from '@/api/apis.js';
import {
  getEzCheckErrorTransferCreation,
  getIsAssigningTransferDealer,
  getIsEZCheckForTransferCreationInProgress,
  getIsTransferCreationAllowed,
  getLicenseDetail,
  getSequalizeValidationError,
  getTotalTransfersCount,
  getezCheckStatusTransferCreation
} from '../ducks/selectors';
import { useDispatch } from 'react-redux';
import {
  callToEZCheckForTransferCreation,
  setEZCheckForTransferCreationMessage,
  setEZCheckStatusTransferCreation,
  setSequalizeValidationError,
  setTotalTransfersCount,
  setisTransferCreationAllowed,
  setCreateTransferData,
  setLicenseeDetail
} from '../ducks/slice';
import { setIsEzCheckHistoryInprogress, setQuery } from '@/explore/ducks/slice';
import { ezMessageMapping } from '@/model/Constants';
import {
  Toastertype,
  TransferDetailsType,
  TransferFormMode,
  TransferModalProps,
  keyType
} from '../types';
import {
  getEightDigitLicenseKey,
  getPrimary,
  getPrimaryValue
} from '@/explore/ffl-detail/utils.mjs';
import { createTransferValidation } from '../ducks/validationSchema';
import { TRANSFER_DETAILS, optOutQueueMessage } from '@/utils/constants';
import { getBusinessDetailsEdited, getDefaultShippingAddressEdited, getQuery } from '@/explore/ducks/selectors';
import ModalComponent from '@/common/Modal';
import { AxiosError } from 'axios';
import AriaSelectDropdown from '@/common/AriaSelectDropdown';
import { Key } from 'react-aria-components';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { createTransferInitValue, getDefaultShippingAddress } from '@/utils/utils';
import { OutlineToasterNotification } from '@/toaster/successNotification';
import { getFormattedDate } from './value-formatters/date-formatter.mjs';
import License from '@/model/license.mjs';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import ExploreV2 from '@/explore/Explore-v2';

interface TransferFormProps {
  licensee?: Licensee;
  createTransfer: React.Dispatch<React.SetStateAction<Transfer>>;
  canCreatetransfer: React.Dispatch<React.SetStateAction<boolean>>;
  isSubmitting: boolean;
  formInitialData?: TransferDetailsType;
  mode?: TransferFormMode;
}

interface Errors {
  notes: string | null;
  buyerName: string | null;
  referenceId: string | null;
  storeURL: string | null;
  sku: string | null;
  buyerPhone: string | null;
  buyerEmail: string | null;
  modelType: string | null;
  street: string | null;
  city: string | null;
  state: string | null;
  zipCode: string | null;
}

interface TransferFormDetails extends Omit<Transfer, 'notes'> {
  notes: string;
}

export function TransferForm({
  licensee: licenseeProp,
  createTransfer,
  canCreatetransfer,
  isSubmitting,
  formInitialData
}: TransferFormProps) {
  console.log("licenseeProp",licenseeProp)
  const location = useLocation();
  const {isOpen: isSearchNewDealerModalOpen, onClose: onCloseSearchNewDealerModal, onOpen: onOpenSearchNewDealerModal} = useDisclosure();
  const [isLoading, setIsLoading] = useState(false);
  const [licenseKey, setLicenseKey] = useState<string>('');
  const [searchString, setSearchString] = useState<string>('');
  const [defaultShippingAddress, setDefaultShippingAddress] = useState<{address: { state: string; street: string; city: string; zipCode: string } | null, type: string}>({address: null, type: ""});
  const [formData, setFormData] = useState<TransferFormDetails>(
    createTransferInitValue
  );
  const [firearm, setFirearm] = useState<string>('');
  const [isBlacklisted, setIsBlacklisted] = useState<boolean>(false);
  const [isOptout, setIsOptout] = useState<boolean>(false);
  const [errors, setErrors] = useState<Errors>({
    notes: null,
    buyerName: null,
    referenceId: null,
    sku: null,
    storeURL: null,
    buyerEmail: null,
    buyerPhone: null,
    modelType: null,
    street: null,
    city: null,
    state: null,
    zipCode: null
  });
  useEffect(() => {
    if (formInitialData && formInitialData.fflMasterDetails) {
      setFirearm(
        formInitialData.TransferDetails.products &&
          formInitialData.TransferDetails.products.length > 0
          ? formInitialData.TransferDetails.products[0]
          : ''
      );
      setFormData({
        referenceId: formInitialData.TransferDetails?.orderId || '',
        buyerName: formInitialData.TransferDetails.buyer.name,
        notes:
          formInitialData.TransferDetails.notes &&
          formInitialData.TransferDetails.notes.length > 0
            ? formInitialData.TransferDetails.notes[0]
            : '',
        firearm:
          formInitialData.TransferDetails.products &&
          formInitialData.TransferDetails.products.length > 0
            ? formInitialData.TransferDetails.products[0]
            : '',
        orderDate: formInitialData.TransferDetails.orderDate
          ? new Date(formInitialData.TransferDetails.orderDate)
          : new Date(),
        storeURL: formInitialData.TransferDetails.storeURL || '',
        sku: formInitialData.TransferDetails.sku || '',
        buyerPhone: formInitialData.TransferDetails.buyer.phone,
        buyerEmail: formInitialData.TransferDetails.buyer.email,
        modelType: formInitialData.TransferDetails.modelType,
        street: formInitialData.TransferDetails.buyer.street || '',
        city: formInitialData.TransferDetails.buyer.city || '',
        state: formInitialData.TransferDetails.buyer.state || '',
        zipCode: formInitialData.TransferDetails.buyer.zipCode || '',
        key: licenseKey
      });
      if(formInitialData.fflMasterDetails?.licenseId) setLicenseKey(
        getEightDigitLicenseKey(formInitialData.fflMasterDetails?.licenseId)
      );
    }
  }, [formInitialData]);
  const licensee = getLicenseDetail()
  const isAssigningTransferDealer = getIsAssigningTransferDealer();
  const isTransferCreationAllowed = getIsTransferCreationAllowed();

  const sequalizeValidationError = getSequalizeValidationError();
  const dispatch = useDispatch();
  const datePickerRef = useRef<any>(null);

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  function setInitialValue() {
    setFirearm('');
    setFormData(createTransferInitValue);
  }

  useEffect(() => {
    if (licenseeProp) {
      setLicenseKey(
        `${
          licenseeProp.id[0] +
          licenseeProp.id.substring(2, 4) +
          licenseeProp.id.substring(licenseeProp.id.length - 5)
        }`
      );
    }
    createTransfer({
      key: licenseKey,
      referenceId: formData.referenceId.trim(),
      firearm: firearm,
      buyerName: formData.buyerName ? formData.buyerName.trim() : '',
      notes: [formData.notes.trim()],
      orderDate: formData.orderDate,
      buyerEmail: formData.buyerEmail ? formData.buyerEmail.trim() : '',
      buyerPhone: formData.buyerPhone,
      sku: formData.sku ? formData.sku.trim() : '',
      storeURL: formData.storeURL ? formData.storeURL.trim() : '',
      modelType: formData.modelType ? formData.modelType.trim() : '',
      street: formData.street ? formData.street.trim() : '',
      city: formData.city ? formData.city.trim() : '',
      state: formData.state ? formData.state.trim() : '',
      zipCode: formData.zipCode ? formData.zipCode.trim() : ''
    });
    if (
      licenseKey &&
      firearm &&
      formData.buyerName &&
      formData.referenceId &&
      formData.buyerEmail &&
      formData.buyerPhone &&
      !errors.buyerName &&
      !errors.notes &&
      !errors.sku &&
      !errors.storeURL &&
      !errors.referenceId &&
      !errors.buyerEmail &&
      !errors.buyerPhone &&
      !errors.modelType &&
      !errors.street &&
      !errors.city &&
      !errors.state &&
      !errors.zipCode
    ) {
      canCreatetransfer(true);
    } else canCreatetransfer(false);
  }, [licenseKey, formData, firearm]);

  const isEZCheckCalled = useRef(false);
  useEffect(() => {
    if (
      (formInitialData || licenseeProp) &&
      !isEZCheckCalled.current &&
      licenseKey
    ) {
      dispatch(callToEZCheckForTransferCreation({ license_key: licenseKey }));
      if (formInitialData && licenseKey) lookupLicensee();
      isEZCheckCalled.current = true;
    }
  }, [licenseKey, licenseeProp]);

  useEffect(() => {
    return () => {
      dispatch(setEZCheckStatusTransferCreation(null));
      dispatch(setisTransferCreationAllowed(false));
      dispatch(setIsEzCheckHistoryInprogress(false));
      dispatch(setEZCheckForTransferCreationMessage(null));
      dispatch(setSequalizeValidationError(null));
    };
  }, []);

  useEffect(() => {
    if (
      licensee?.optOutOptions === 'all' ||
      licensee?.optOutOptions === 'store'
    ) {
      setIsOptout(true);
    } else {
      setIsOptout(false);
    }
  }, [licensee]);
  const licenseSearchHandler = ()=> {
    setIsLoading(true);
    dispatch(setQuery([searchString]))
  }

  function lookupLicensee() {
    setIsLoading(true)
    LicenseById(
      licenseKey.substring(0, 3),
      licenseKey.substring(licenseKey.length - 5)
    )
      .then((data: Licensee) => {
        if (!data.id) {
          dispatch(setLicenseeDetail(null))
        }
        setIsBlacklisted(data.isBlacklisted);
        dispatch(setLicenseeDetail({
          id: data.id,
          name: data.name,
          license_key: data.license_key,
          contact: {
            address: {
              street1: data.contact.address?.street1,
              city: data.contact.address?.city,
              state: data.contact.address?.state,
              zip: data.contact.address?.zip
            },
            mailAddress: {
              street: data.contact.mailAddress?.street,
              city: data.contact.mailAddress?.city,
              state: data.contact.mailAddress?.state,
              zip: data.contact.mailAddress?.zip
            },
            formattedPhoneNumbers: data?.contact?.formattedPhoneNumbers,
            formattedEmails: data?.contact?.formattedEmails
          },
          optOutOptions: data.optOutOptions,
          defaultShippingAddress: data.defaultShippingAddress,
          customAddress: data.customAddress
        } as Licensee));
      })
      .catch((e) => {
        console.log(String(e));
        dispatch(setLicenseeDetail(null))
      })
      .finally(() => setIsLoading(false));
  }
  function renderLicenseId() {
    if (licenseeProp) {
      return <Box>{licenseeProp.id}</Box>;
    }
    return (
      <div className="transfer-form__search-result">
        <Input
          isDisabled={isSubmitting}
          type="text"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setSearchString(e.target.value)
          }
          placeholder="Search a FFL number, Zip code, Control number, Business Name, City, Email, Phone number here....."
          value={searchString}
        />
        <Button
          isDisabled={isSubmitting || !searchString}
          onClick={() => {
            licenseSearchHandler();
            onOpenSearchNewDealerModal()
          }}
          className="transfer-form__search-btn"
        >
          <img src="/images/ui/search-icon-blue.svg" />
        </Button>
      </div>
    );
  }

  const validateField = async (name: string, value: string) => {
    try {
      await createTransferValidation.validateAt(name, { [name]: value });
      setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    } catch (error: any) {
      if (error.errors && error.errors.length > 0) {
        canCreatetransfer(false);
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: error.errors[0]
        }));
      }
    }
  };

  const onDateChange = (date: Date) => {
    console.log('date', getFormattedDate(date));
    setFormData((prevData: any) => ({
      ...prevData,
      orderDate: getFormattedDate(date)
    }));
  };

  const onPhoneAndPinChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const inputName = event.target.name;
    let inputVal = event.target.value;
    const regex = /^[0-9\b]+$/;
    const val = inputVal.replace(/\D/g, '');
    const maxLength = inputName === 'buyerPhone' ? 10 : 5;
    if (inputVal === '' || regex.test(inputVal)) {
      if (val.length >= maxLength) {
        inputVal = val.slice(0, maxLength);
      }
      setFormData((prevData: any) => ({
        ...prevData,
        [inputName]: inputVal
      }));
      if (inputVal === '' || inputVal.length === maxLength) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [inputName]: ''
        }));
      } else {
        validateField(inputName, inputVal);
      }
    }
  };

  const onChangeInput = async (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const inputName = event.target.name;
    let inputVal = event.target.value;
    setFormData((prevData: any) => ({
      ...prevData,
      [inputName]: inputVal
    }));
    if (
      inputVal === ''
    ) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [inputName]: ''
      }));
    } else {
      validateField(inputName, inputVal);
    }
  };
  const businessDetailsEdited = getBusinessDetailsEdited();
  const phones =
    businessDetailsEdited.phones && licenseeProp
      ? businessDetailsEdited.phones
      : licensee?.contact?.formattedPhoneNumbers || [];
  const emails =
    businessDetailsEdited.emails && licenseeProp
      ? businessDetailsEdited.emails
      : licensee?.contact.formattedEmails || [];

  useEffect(() => {
    console.log("licensee", licensee)
    if(licensee){
      setDefaultShippingAddress(getDefaultShippingAddress(licensee))
      licensee?.license_key && setLicenseKey(licensee?.license_key)
    }
  }, [licensee]);

  const ModalLoader = () => {
    return (<div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.3)", zIndex: "10000", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Spinner />
    </div>)
  }
  const queryParams = new URLSearchParams(location.search);
  const pendingTransferId = queryParams.get('pending_transfer_id');
  
  return (
    <Box className="transfer-form-wrapper transfer-form--create-modal">
      <ModalComponent
        footer={null}
        isOpen={isSearchNewDealerModalOpen}
        onClose={()=>{
          dispatch(setLicenseeDetail(null))
          onCloseSearchNewDealerModal()
          setIsLoading(false)
        }}
        children={
          <>
            <ExploreV2
              cognitoGroup={false}
              isSuperAdmin={false}
              isStoreAdmin={true}
              isAssignDealerModal={true}
              assignNewDealerInitialZipCode={searchString}
              onCloseAssignDealerModal={()=>{
                onCloseSearchNewDealerModal();
                setIsLoading(false)
              }}
              transferId={pendingTransferId as string}
              type={"initial-transfer"}
            />
            {isAssigningTransferDealer && <ModalLoader />}
          </>
        }
        title={"Assign New License"}
        variant={2}
        maxWidth='1360px'
        className="assign-new-dealer-modal"
      />
      <form className="transfer-form">
        <div className="transfer-from__grid">
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">
              Search a FFL Dealer:
            </FormLabel>
            <Box>
              <Box marginBottom={'15px'}>{renderLicenseId()}</Box>
              <FormLabel className="transfer-form__label">
                  License Number:
                </FormLabel>
                <Box display="flex" flexDirection="column">
                  <Box className="transfer-form__license-info">
                    {licenseKey? licenseKey : '-'}
                  </Box>
                </Box>
            </Box>
          </FormControl>
          {
            <>
              <FormControl className="transfer-form__item">
                <FormLabel className="transfer-form__label">
                  License Information:
                </FormLabel>
                {isLoading ? <Spinner size="sm" /> : 
                licensee && defaultShippingAddress && defaultShippingAddress?.address ? (
                  <Box display="flex" flexDirection="column">
                    <Box className="transfer-form__license-info">
                      {licensee?.name}
                    </Box>
                    <Box className="transfer-form__license-info">
                      {defaultShippingAddress?.address.street}
                    </Box>
                    <Box className="transfer-form__license-info">
                      {defaultShippingAddress.address?.city},{" "}
                      {defaultShippingAddress.address?.state}{" "}
                      {defaultShippingAddress.address?.zipCode}
                    </Box>
                  </Box>
                ) : (
                  '-'
                )}
              </FormControl>
              <FormControl className="transfer-form__item">
                <FormLabel className="transfer-form__label">
                  Email ID:
                </FormLabel>
                <Box display="flex" flexDirection="column">
                  {isLoading ? <Spinner size="sm" /> :<Box className="transfer-form__license-info">
                    {emails && emails.length > 0 ? getPrimary(emails) : '-'}
                  </Box>}
                </Box>
              </FormControl>
              <FormControl className="transfer-form__item">
                <FormLabel className="transfer-form__label">
                  Phone number:
                </FormLabel>
                {isLoading ? <Spinner size="sm" /> : <Box display="flex" flexDirection="column">
                  <Box className="transfer-form__license-info">
                    {phones && phones.length > 0
                      ? getPrimaryValue(phones)
                      : '-'}
                  </Box>
                </Box>}
              </FormControl>
            </>
          }
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">Order ID*:</FormLabel>
            <Box display="flex" flexDirection="column">
              <Input
                type="text"
                isDisabled={
                  isSubmitting ||
                  !isTransferCreationAllowed ||
                  isOptout ||
                  isBlacklisted
                }
                onChange={onChangeInput}
                placeholder="Enter Order ID"
                name="referenceId"
                className="transfer-form__input"
                value={formData.referenceId}
              />
              <FormHelperText className="ez-check-status failed">
                {sequalizeValidationError}
              </FormHelperText>
              {errors.referenceId && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.referenceId}
                  </Text>
                </Box>
              )}
            </Box>
          </FormControl>
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">Order Date:</FormLabel>
            <Box display="flex" flexDirection="column">
              <DatePicker
                selected={
                  formData.orderDate ? new Date(formData.orderDate) : null
                }
                showIcon
                name="date-input"
                dateFormat="MM-dd-yyyy"
                placeholderText="MM-DD-YYYY"
                className="transfer-form__input order-date-picker"
                onChange={(date: Date) => onDateChange(date)}
                ref={datePickerRef}
                disabled={
                  isSubmitting ||
                  !isTransferCreationAllowed ||
                  isOptout ||
                  isBlacklisted
                }
                icon={
                  <img
                    src="/images/ui/calendar-primary.svg"
                    onClick={openDatePicker}
                    style={{ cursor: 'pointer' }}
                    alt="calendar"
                  />
                }
              />
            </Box>
          </FormControl>
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">SKU:</FormLabel>
            <Box>
              <Box>
                <Input
                  type="text"
                  onChange={onChangeInput}
                  value={formData.sku}
                  name="sku"
                  className="transfer-form__input"
                  placeholder="Enter SKU"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                />
              </Box>
              {errors.sku && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.sku}
                  </Text>
                </Box>
              )}
            </Box>
          </FormControl>
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">Store URL:</FormLabel>
            <Box>
              <Box>
                <Input
                  type="text"
                  onChange={onChangeInput}
                  value={formData.storeURL}
                  name="storeURL"
                  className="transfer-form__input"
                  placeholder="Enter Store URL"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                />
              </Box>
              {errors.storeURL && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.storeURL}
                  </Text>
                </Box>
              )}
            </Box>
          </FormControl>
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">Buyer Name*:</FormLabel>
            <Box>
              <Box>
                <Input
                  type="text"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                  onChange={onChangeInput}
                  value={formData.buyerName}
                  name="buyerName"
                  className="transfer-form__input"
                  placeholder="Enter Buyer Name"
                />
              </Box>
              {errors.buyerName && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.buyerName}
                  </Text>
                </Box>
              )}
            </Box>
          </FormControl>
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">
              Buyer Phone Number*:
            </FormLabel>
            <Box>
              <Box>
                <Input
                  type="text"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                  onChange={onPhoneAndPinChange}
                  value={formData.buyerPhone}
                  name="buyerPhone"
                  className="transfer-form__input"
                  placeholder="Enter Buyer Number"
                />
              </Box>
              {errors.buyerPhone && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.buyerPhone}
                  </Text>
                </Box>
              )}
            </Box>
          </FormControl>
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">
              Buyer Email*:
            </FormLabel>
            <Box>
              <Box>
                <Input
                  type="text"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                  onChange={onChangeInput}
                  value={formData.buyerEmail}
                  name="buyerEmail"
                  className="transfer-form__input"
                  placeholder="Enter Buyer Email"
                />
              </Box>
              {errors.buyerEmail && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.buyerEmail}
                  </Text>
                </Box>
              )}
            </Box>
          </FormControl>
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">Model:</FormLabel>
            <Box>
              <Box>
                <Input
                  type="text"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                  onChange={onChangeInput}
                  value={formData.modelType}
                  name="modelType"
                  className="transfer-form__input"
                  placeholder="Enter Model"
                />
              </Box>
              {errors.modelType && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.modelType}
                  </Text>
                </Box>
              )}
            </Box>
          </FormControl>
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">
              Buyer Address:
            </FormLabel>
            <Box>
              <Box>
                <Input
                  type="text"
                  onChange={onChangeInput}
                  value={formData.street}
                  name="street"
                  className="transfer-form__input"
                  placeholder="Enter Street"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                />
              </Box>
              {errors.street && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.street}
                  </Text>
                </Box>
              )}
            </Box>
            <Box marginTop={'10px'}>
              <Box>
                <Input
                  type="text"
                  onChange={onChangeInput}
                  value={formData.state}
                  name="state"
                  className="transfer-form__input"
                  placeholder="Enter State"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                />
              </Box>
              {errors.state && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.state}
                  </Text>
                </Box>
              )}
            </Box>
            <Box marginTop={'10px'}>
              <Box>
                <Input
                  type="text"
                  onChange={onChangeInput}
                  value={formData.city}
                  name="city"
                  className="transfer-form__input"
                  placeholder="Enter City"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                />
              </Box>
              {errors.city && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.city}
                  </Text>
                </Box>
              )}
            </Box>
            <Box marginTop={'10px'}>
              <Box>
                <Input
                  type="text"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                  onChange={onPhoneAndPinChange}
                  value={formData.zipCode}
                  name="zipCode"
                  className="transfer-form__input"
                  placeholder="Enter Zip Code"
                />
              </Box>
              {errors.zipCode && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.zipCode}
                  </Text>
                </Box>
              )}
            </Box>
          </FormControl>

          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">
              {TRANSFER_DETAILS.FIREARM_TYPE}*:
            </FormLabel>
            <Box marginBottom={"10px"}>
              <AriaSelectDropdown
                aria-label="Firearm"
                onChangeDropdown={(value: Key) => setFirearm(value as string)}
                selectedOption={firearm}
                options={Object.entries(FirearmType)}
                variant="light"
                isDisabled={
                  isSubmitting ||
                  !isTransferCreationAllowed ||
                  isOptout ||
                  isBlacklisted
                }
                className="react-aria-Select react-aria-select-light"
                placeholder="-Select Firearm Type-"
              />
              {/* <Select
                isDisabled={
                  isSubmitting || !isTransferCreationAllowed || isOptout
                }
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  setFirearm(e.target.value)
                }
                className={`transfer-form__input ${
                  !firearm && 'transfer-form__unselected'
                }`}
                placeholder="-Select Firearm Type-"
              >
                {Object.entries(FirearmType)
                  .map((entry, i) => (
                    <option key={i} value={entry[0]}>
                      {entry[1]}
                    </option>
                  ))}
              </Select> */}
            </Box>
            <FormLabel className="transfer-form__label">Notes:</FormLabel>
            <Box>
              <Box>
                <Textarea
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                  onChange={onChangeInput}
                  value={formData.notes}
                  name="notes"
                  className="transfer-form__textarea"
                />
              </Box>

              {errors.notes && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.notes}
                  </Text>
                </Box>
              )}
            </Box>
          </FormControl>
        </div>
      </form>
    </Box>
  );
}

export default function TransferModal({
  isOpen,
  onClose,
  licensee,
  refetchData
}: TransferModalProps) {
  const [isCreatingTransfer, setIsCreatingTransfer] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [createTransferValues, setCreateTransferValues] = useState<Transfer>({
    key: '',
    referenceId: '',
    firearm: '',
    status: '',
    buyerName: '',
    agent: '',
    notes: [''],
    orderDate: null,
    storeURL: '',
    buyerPhone: '',
    buyerEmail: '',
    modelType: '',
    street: '',
    city: '',
    state: '',
    zipCode: ''
  });
  const totalTransferCount = getTotalTransfersCount();
  const defaultShippingAddressEdited = getDefaultShippingAddressEdited();
  const defaultShippingAddress = licensee ? (defaultShippingAddressEdited || licensee.defaultShippingAddress) : undefined;
  const navigate = useNavigate();

  const handleModalAction = (response: Transfer | null) => {
    return () => {
      navigate(`/transfers/${response?.id}`);
    };
  };
  async function callCreateTransferApi() {
    setIsCreatingTransfer(true);
    try {
      const {
        street,
        city,
        state,
        zipCode,
        buyerPhone,
        buyerEmail,
        buyerName,
        key,
        referenceId,
        ...restCrateTransferPayload
      } = createTransferValues;
      const createTransferPayload = {
        licenseKey: key,
        orderId: referenceId,
        buyer: {
          street: street || '',
          city: city || '',
          state: state || '',
          zipCode: zipCode || '',
          phone: buyerPhone || '',
          email: buyerEmail || '',
          name: buyerName || ''
        },
        ...restCrateTransferPayload
      };
      const response: Transfer = await createTransfer(createTransferPayload);
      if (response) {
        dispatch(setTotalTransfersCount(totalTransferCount + 1));
        OutlineToasterNotification(
          Toastertype.success,
          `Great! Your transfer has been successfully created.`,
          handleModalAction(response)
        );
      }
      onClose();
      if (refetchData) {
        refetchData();
      }
    } catch (err) {
      const error = err as AxiosError<{ code: number }>;
      if (error?.response?.data?.code === 71)
        dispatch(
          setSequalizeValidationError(
            'Order ID already exists. Enter an unique ID'
          )
        );
      console.log(err);
    } finally {
      dispatch(setLicenseeDetail(null))
      setIsCreatingTransfer(false);
      setDisabled(false);
    }
  }
  return (
    <ModalComponent
      title="Create a New Transfer"
      isOpen={isOpen}
      onClose={onClose}
      variant={2}
      modalType="createTransfer"
      footer={
        <>
          <Button
            colorScheme="blue"
            background="#ffffff"
            color="#0C1E46"
            border="1px solid #0C1E46"
            padding="8px 11px"
            marginRight="20px"
            isDisabled={isCreatingTransfer}
            onClick={() => {
              onClose();
              setDisabled(false);
            }}
          >
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            background="#0C1E46"
            padding="8px 20px"
            onClick={callCreateTransferApi}
            isLoading={isCreatingTransfer}
            isDisabled={!disabled || isCreatingTransfer}
          >
            Save
          </Button>
        </>
      }
    >
      <TransferForm
        licensee={licensee ? {...licensee, defaultShippingAddress} : undefined}
        createTransfer={setCreateTransferValues}
        canCreatetransfer={setDisabled}
        isSubmitting={isCreatingTransfer}
      />
    </ModalComponent>
  );
}